import React from 'react';
import FeaturesGrid from './FeaturesGrid';

const ModuleAreas = ({ module, onView }) => {
  return <FeaturesGrid id={module.id} onView={onView} />

}

export default ModuleAreas;
